import uri from 'urijs';
import createAction from '../services/create-action';
import { buildPaginationRequestParams } from '../services/pagination';

export const FETCH_POSTS_REQUEST = 'posts/FETCH_REQUEST';
export const FETCH_POSTS_SUCCESS = 'posts/FETCH_SUCCESS';
export const FETCH_POSTS_FAILURE = 'posts/FETCH_FAILURE';

export const fetchPostsRequest = createAction(FETCH_POSTS_REQUEST, payload => payload, (payload, meta) => meta);
export const fetchPostsSuccess = createAction(FETCH_POSTS_SUCCESS, payload => payload, (payload, meta) => meta);
export const fetchPostsFailure = createAction(FETCH_POSTS_FAILURE, payload => payload, (payload, meta) => meta);

export default function fetchPosts({ categoryId, page, pageSize }) {
  return (dispatch, getState, { request }) => {
    dispatch(fetchPostsRequest(undefined, { categoryId }));

    const params = buildPaginationRequestParams(page, pageSize);

    const promise = request(uri('/_api/posts').query({ categoryId, ...params }), { parseHeaders: true });

    return promise
      .then(({ body = [], headers = {} }) =>
        dispatch(
          fetchPostsSuccess(body, {
            categoryId,
            page,
            entityCount: parseInt(headers.get('Wix-Forum-TotalResults'), 10),
          })
        )
      )
      .catch(() => dispatch(fetchPostsFailure(undefined, { categoryId })))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/fetch-posts.js